import React from "react";
import { Center, Spinner } from "@chakra-ui/react";

export const Preloader = () => (
  <Center h="100vh">
    <Spinner />
  </Center>
);
